import { motion } from "framer-motion";
import {
  ArrowRight,
  PlayCircle,
  Sparkles,
  BrainCircuit,
  GraduationCap,
  BarChart3,
} from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-slate-950 min-h-screen flex items-center">

      {/* Background */}

      <div className="absolute inset-0">

        <div className="absolute top-20 left-20 h-72 w-72 rounded-full bg-cyan-500/20 blur-[120px]" />

        <div className="absolute bottom-20 right-20 h-72 w-72 rounded-full bg-blue-600/20 blur-[120px]" />

      </div>

      <div className="container mx-auto px-6 relative z-10">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT */}

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: .8 }}
          >

            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-4 py-2 text-cyan-300 text-sm mb-8">

              <Sparkles size={18} />

              Future Learning Platform

            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-tight text-white">

              Build Better
              <br />

              Skills with

              <span className="block bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">

                AI Learning

              </span>

            </h1>

            <p className="text-slate-400 text-lg mt-8 leading-8 max-w-xl">

              Modern learning experience powered by AI.
              Upskill your employees, improve competency,
              and accelerate business transformation with one platform.

            </p>

            <div className="flex gap-5 mt-10">

              <button className="group flex items-center gap-2 rounded-xl bg-cyan-500 px-7 py-4 font-semibold text-slate-950 transition hover:bg-cyan-400">

                Explore Platform

                <ArrowRight
                  size={18}
                  className="transition group-hover:translate-x-1"
                />

              </button>

              <button className="flex items-center gap-3 rounded-xl border border-slate-700 px-7 py-4 text-white hover:bg-slate-900">

                <PlayCircle size={22} />

                Watch Demo

              </button>

            </div>

          </motion.div>

          {/* RIGHT */}

          <motion.div
            initial={{ opacity: 0, scale: .9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: .8 }}
            className="relative"
          >

            <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8">

              <div className="grid grid-cols-2 gap-6">

                <Card
                  icon={<BrainCircuit size={30} />}
                  title="AI Coach"
                  text="Interactive learning powered by AI."
                />

                <Card
                  icon={<GraduationCap size={30} />}
                  title="Certification"
                  text="Official learning certification."
                />

                <Card
                  icon={<BarChart3 size={30} />}
                  title="Analytics"
                  text="Track every learner progress."
                />

                <Card
                  icon={<Sparkles size={30} />}
                  title="Smart Learning"
                  text="Adaptive learning path."
                />

              </div>

            </div>

          </motion.div>

        </div>

      </div>

    </section>
  );
}

function Card({ icon, title, text }) {
  return (
    <motion.div
      whileHover={{
        y: -8,
      }}
      className="rounded-2xl border border-white/10 bg-slate-900/60 p-6"
    >
      <div className="w-14 h-14 rounded-xl bg-cyan-500/10 flex items-center justify-center text-cyan-400 mb-5">

        {icon}

      </div>

      <h3 className="text-white font-bold text-lg">

        {title}

      </h3>

      <p className="text-slate-400 mt-3 text-sm leading-6">

        {text}

      </p>
    </motion.div>
  );
}